export default __webpack_public_path__ + "static/media/0021.50c118ff.png";